<template>
	<div>
		<Card>
			<transition name="fade">
			    <Row v-if="mainTable.logisticsSarchCardShow"
			        :gutter="16">
			        <Col span="24">
			        <search-card :form="mainTable.searchlogisticsForm"
			            :table-load-event="getMainTableRecords"
			            :table-search="mainTable.tableSearch"
			            :colSpan="6"
			            :searchBtnColSpan="4" />
			        </Col>
			    </Row>
			</transition>

			<Row :gutter="16">
			    <Col span="24">
			    <div class="global-tool-bar">
			        <div class="left-bar">
			            <span class="title">物流信息列表</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:10px;"
						    @on-change="onUserTypeChange">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
			        </div>
			        <div class="right-bar">
			        	<Button type="primary"
							size="small"
							class="btns"
							shape="circle"
							icon="ios-search"
							@click="mainTable.logisticsSarchCardShow = !mainTable.logisticsSarchCardShow">
							搜索</Button>
					</div>
			    </div>
			    </Col>
			</Row>

			<Row :gutter="16">
			    <Col span="24">
			    <stand-pagination-table :columns="mainTable.columns"
			        :data="mainTable.data"
			        :loading="mainTable.tableLoading"
			        :table-search="mainTable.tableSearch"
			        :table-load-event="getMainTableRecords" />
			    </Col>
			</Row>

			<Modal v-model="logisticsFromShow"
			        title="物流信息">
			        <Form label-position="top">
						<Row :gutter="16">
							<Col span="12">
							<FormItem label="发货单号">
							    <Input :value="logisticsFrom.sendOrderNo" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="发货苗场">
							    <Input :value="logisticsFrom.seedFarm" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="发货时间">
							    <Input :value="formatDateTimeString(logisticsFrom.sendTime)" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="收货地址">
							    <Input :value="logisticsFrom.receiveAddress" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="快递单号">
							    <Input :value="logisticsFrom.shippingNo" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="快递公司">
							    <Input :value="logisticsFrom.shippingCompany" readonly></Input>
							</FormItem>
							</Col>
							<Col span="12">
							<FormItem label="派送状态">
							   <Input :value="logisticsFrom.shippingStatusStr" readonly></Input>
							</FormItem>
							</Col>
						</Row>
					</Form>
			    </Modal>
		</Card>
	</div>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import search from "@/libs/search";
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import { getPageShippingList } from '@/api/modules/preSale-management/preSale-delivery';
export default{
    name:'LogisticsInformationList',
    components: {
		    StandPaginationTable,
        SearchCard
    },
    data(){
        return{
            userType:'F',
            mainTable:{
                columns:[
                    { title: "发货单号", key: "sendOrderNo", align:'center' },
                    { title: "发货苗场", key: "seedFarm", align:'center' },
                    { title: "发货时间", key: "sendTime", align:'center', width: 130, render: (h, params) => dateTimeRender(h, params.row.sendTime) },
                    { title: "会员名", key: "userName", align:'center' },
                    { title: "收货人", key: "customerName", align:'center' },
                    { title: "联系电话", key: "contactNumber", align:'center' },
                    { title: "收货地址", key: "receiveAddress", align:'center' },
                    { title: "快递单号", key: "shippingNo", align:'center', width: 160 },
                    { title: "快递公司", key: "shippingCompany", align:'center', width: 160 },
                    {
						    title: '派送状态', key: 'shippingStatus', align: 'center',
						    render: (h, params) => {
                            let text ='未发货';
                            let color ='black';
                            if(params.row.shippingStatus==1){
                                text ='派送中';
                                color ='black';
                            }
                            else if(params.row.shippingStatus==2){
                                text ='已收货';
                                color ='green';
                            }
                            else if(params.row.shippingStatus==3){
                                text ='派送失败';
                                color ='red';
                            }
						        return h('div', [
						            h('span', {
						                style: {
						                    color: color
						                }
						            }, text)
						        ]);
						    }
                    },
                    {
						    title: '操作',
						    key: 'action',
						    align: 'center',
                        width: 120,
						    render: (h, params) => {
						        return h('div', [
						            h('Button', {
						                props: {
						                    type: 'text',
						                    size: 'small'
						                },
						                style: {},
						                on: {
						                    click: () => {
						                        this.onLogisticsShow(params.row);
						                    }
						                }
						        }, '查看',)]);
						    }
                    }
                ],
                data:[],
                searchlogisticsForm:[
                    { label: '发货单号', type: 'Input', value: '', name: 'sendOrderNo', sql: 'like' },
                    { label: '发货苗场', type: 'Input', value: '', name: 'seedFarm', sql: 'like' },
                    { label: '发货时间', type: 'Daterange', value: '', name: 'sendTime', sql: 'dateBetween' },
                    { label: '快递单号', type: 'Input', value: '', name: 'shippingNo', sql: 'like' },
                    { label: '快递公司', type: 'Input', value: '', name: 'shippingCompany', sql: 'like' }
                ],
                tableLoading:false,
                tableSearch:search.getSearchParams(),
                logisticsSarchCardShow:false
            },
            logisticsFrom:{
                shippingNo:'',
                sendOrderNo:'',
                seedFarm:'',
                sendTime:'',
                receiveAddress:'',
                shippingStatusStr:''
            },
            logisticsFromShow:false
        };
    },
    mounted(){
        this.init();
    },
    methods:{
        formatDateString,
        formatDateTimeString,
        init() {
			    this.getMainTableRecords();
        },
        onLogisticsShow(row){
            this.logisticsFrom.shippingNo=row.shippingNo;
            this.logisticsFrom.sendOrderNo = row.sendOrderNo;
            this.logisticsFrom.seedFarm = row.seedFarm;
            this.logisticsFrom.sendTime = row.sendTime;
            this.logisticsFrom.receiveAddress = row.receiveAddress;
            if(row.shippingStatus==0){
                this.logisticsFrom.shippingStatusStr = "未发货";
            }
            else if(row.shippingStatus==1){
                this.logisticsFrom.shippingStatusStr = "派送中";
            }
            else if(row.shippingStatus==2){
                this.logisticsFrom.shippingStatusStr = "已收货";
            }
            else{
                this.logisticsFrom.shippingStatusStr = "派送失败";
            }

            this.logisticsFromShow = true;
        },
        onUserTypeChange(e) {
			    this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
				    search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
				    this.mainTable.tableSearch.filters.enable = true;
				    this.mainTable.tableSearch.filters.conditions.push({
				        name: 'memberType',
				        type: 'eq',
				        value: this.userType
				    });
            }
            getPageShippingList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style>
</style>
